import { getUserRoleName, getUserStateName, UserRole } from "features/auth/types/user";
import { useUserContext } from "context/UserContext";
import DataLabel from "components/DataLabel";
import { Stack } from "@mui/material";

const ProfileUserData: React.FC = () => {
  const user = useUserContext();

  return (
    <Stack spacing={1}>
      <DataLabel label="E-post">{user.email || "-"}</DataLabel>

      {user.appleId && <DataLabel label="Apple-ID">{user.appleId || "-"}</DataLabel>}

      <DataLabel label="Telefon">{user.phone || "-"}</DataLabel>

      <DataLabel label="Roll">{getUserRoleName(user.role)}</DataLabel>

      <DataLabel label="Status">{getUserStateName(user.state)}</DataLabel>

      {user.role && user.role !== UserRole.EXTERNAL_INSTALLER && (
        <>
          <DataLabel label="Avdelning">
            {user.departments.map((dept) => dept.name).join(", ") || "-"}
          </DataLabel>

          <DataLabel label="Kontor">{user.office?.name || "-"}</DataLabel>

          <DataLabel label="Anställningsnummer">{user.anstnrHogia || "-"}</DataLabel>

          <DataLabel label="Attesterare">{user.controllerName || "-"}</DataLabel>
        </>
      )}

      {(user.role === UserRole.ADMIN ||
        user.role === UserRole.USER_ADMIN ||
        user.role === UserRole.SALES) && (
        <DataLabel label="Pyramid-signatur">{user.pyramidSignature || "-"}</DataLabel>
      )}

      {user.role === UserRole.INTERNAL_INSTALLER && (
        <>
          <DataLabel label="Tidkod (installation)">{user.articleTime || "-"}</DataLabel>
          <DataLabel label="Tidkod (restid i bil)">{user.articleTimeInCar || "-"}</DataLabel>
        </>
      )}

      {user.role === UserRole.EXTERNAL_INSTALLER && (
        <DataLabel label="Företag">{user.companyName || "-"}</DataLabel>
      )}
    </Stack>
  );
};

export default ProfileUserData;
